import { toast } from 'vue-sonner'

export function useToast() {
  return {
    success(title: string, description?: string): void {
      toast.success(title, { description })
    },
    error(title: string, description?: string): void {
      toast.error(title, { description, duration: 10000 })
    },
  }
}
